export default __webpack_public_path__ + "static/media/options.b4f230d6.svg";